import { createContext, ReactNode, useContext } from 'react';
import { TimeTrackingManageDialog, TimeTrackingManageMode } from './TimeTrackingManageDialog';
import { useDocument } from '../../context';
import { ICancelDialogResult, useDialog } from '@tap/tap-ui';
import { TimeTrackingLogProps, useTimeTrackingLog } from './TimeTrackingLog';
import { ApiTimeTrackingLog } from '@tap/data-providers';

/*
*   Провайдер для TimeTracking
*/

export type TimeTrackingContextValue = {
    openAddTimeTrackingDialog: () => void,
    openEditTimeTrackingDialog: (item: ApiTimeTrackingLog) => void,
    openDeleteTimeTrackingDialog: (item: ApiTimeTrackingLog) => void,
    timeTrackingLogProps: TimeTrackingLogProps,
}

export const TimeTrackingContext = createContext<TimeTrackingContextValue | null>(null);

export type TimeTrackingProviderProps = {
    children?: ReactNode,
}


export const TimeTrackingProvider = ({ children }: TimeTrackingProviderProps): JSX.Element => {

    const { documentKey, documentState } = useDocument();

    const handleCloseDialog = ({ isCancel }: ICancelDialogResult) => {
        if (!isCancel) {
            timeTrackingLogProps.fetchData();
            documentState.fetchData();
        }
    };

    const TimeTrackingManageReadyDialog = useDialog(TimeTrackingManageDialog, handleCloseDialog);

    const openAddTimeTrackingDialog = () => {
        const dialogMode = TimeTrackingManageMode.Create;
        TimeTrackingManageReadyDialog.open({ dialogMode, documentKey });
    }

    const openEditTimeTrackingDialog = (item: ApiTimeTrackingLog) => {
        const dialogMode = TimeTrackingManageMode.Edit;
        TimeTrackingManageReadyDialog.open({ dialogMode, documentKey, item });
    }

    const openDeleteTimeTrackingDialog = (item: ApiTimeTrackingLog) => {
        const dialogMode = TimeTrackingManageMode.Delete;
        TimeTrackingManageReadyDialog.open({ dialogMode, documentKey, item });
    }

    const timeTrackingLogProps = useTimeTrackingLog({ openAddTimeTrackingDialog, openEditTimeTrackingDialog, openDeleteTimeTrackingDialog });

    return (
        <TimeTrackingContext.Provider
            value={{
                openAddTimeTrackingDialog,
                openEditTimeTrackingDialog,
                openDeleteTimeTrackingDialog,
                timeTrackingLogProps,
            }}
        >
            {children}
            <TimeTrackingManageReadyDialog.Component />
        </TimeTrackingContext.Provider>
    );
};

export const useTimeTracking = (): TimeTrackingContextValue => {
    const context = useContext(TimeTrackingContext);

    if (context == null) {
        throw new Error('No TimeTrackingContext provided');
    }

    return context;
};

